import React from 'react';
import DeviceFullInfoControlPanel from './components/DeviceFullInfoControlPanel/DeviceFullInfoControlPanel';
import Info from './components/Info/Info';
import Controls from './components/Controls/Controls';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './DeviceFullInfoView.module.scss';

const DeviceFullInfoView: React.FC = () => {
	return (
		<div data-test="DeviceFullInfoView">
			<DeviceFullInfoControlPanel />
			<div className={style.content}>
				<Info />
				<Controls />
				<ModalWindows />
			</div>
		</div>
	);
};

export default DeviceFullInfoView;
